import { GetStaticPropsContext } from 'next';

import { AccreditationPageContent } from '~/features/accreditation/components/accreditation-page-content';
import { mastersAiContent } from '~/features/accreditation/configs/masters-ai-content';
import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { useSessionReplay } from '~/features/session-replay';

export default function MastersAILandingPage({ page }: { page: Page }) {
  useSessionReplay();

  return (
    <>
      <PageHead page={page} />
      <PageLayout withoutVerticalPadding>
        <AccreditationPageContent {...mastersAiContent} />
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  // Stop additional locale pages except the default locale from being built
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const page = await getPage('/masters-artificial-intelligence');

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      page,
    },
  };
}
